export const defaultKeys = {
  groupIdKey: `id`,
  groupTitleKey: `title`,
  groupRightTitleKey: `rightTitle`,
  groupLayersKey: `layers`,
  itemIdKey: `id`,
  itemTitleKey: `title`,
  itemDivTitleKey: `title`,
  itemGroupKey: `group`,
  itemTimeStartKey: `start_time`,
  itemTimeEndKey: `end_time`,
  itemLayerKey: `layer`,
}

export const defaultTimeSteps = {
  second: 1,
  minute: 1,
  hour: 1,
  day: 1,
  month: 1,
  year: 1,
}

export const defaultHeaderLabelFormats = {
  yearShort: `YY`,
  yearLong: `YYYY`,
  monthShort: `MM/YY`,
  monthMedium: `MM/YYYY`,
  monthMediumLong: `MMM YYYY`,
  monthLong: `MMMM YYYY`,
  dayShort: `L`,
  dayLong: `dddd, LL`,
  hourShort: `HH:00`,
  hourMedium: `HH:00`,
  hourMediumLong: `L, HH:00`,
  hourLong: `dddd, LL, HH:00`,
  time: `LLL`,
}

export const defaultSubHeaderLabelFormats = {
  yearShort: `YY`,
  yearLong: `YYYY`,
  monthShort: `MM`,
  monthMedium: `MMM`,
  monthLong: `MMMM`,
  dayShort: `dd[\n]DD`,
  dayMedium: `dd[\n]DD`,
  dayMediumLong: `dd[\n]DD`,
  dayLong: `dd[\n]DD`,
  hourShort: `HH:00`,
  hourLong: `HH:00`,
  minuteShort: `mm`,
  minuteLong: `HH:mm`,
}
